import React, { lazy } from 'react'
import Loadable from '../../components/Loadable/Loadable'
import { Page } from '../../Pages'
import { ShowIfRole } from '../../auth/AuthGuard'

const MeasurementPage = Loadable(lazy(() => import('./Measurement')))

const MeasurementRoutes = [
	{
		path: Page.measurement.path,
		children: [
			{
				path: ':dev_eui?',
				element: (
					<ShowIfRole role={Page.measurement.auth}>
						<MeasurementPage />
					</ShowIfRole>
				)
			},
			{
				path: '',
				element: (
					<ShowIfRole role={Page.measurement.auth}>
						<MeasurementPage />
					</ShowIfRole>
				)
			}
		],
		auth: Page.measurement.auth
	}
]

export default MeasurementRoutes
